import { useNavigate } from "react-router-dom";

interface ManagementOptionProps {
  onTitle: string;
  onSubTitle: string;
  onNavigation: string;
  onIcon?: any;
}

const ManagementOption = (props: ManagementOptionProps) => {
  const navigate = useNavigate();

  return (
    <div className="management__option">
      <div
        style={{
          color: "#1e2a4e",
          fontWeight: "900",
          fontSize: "26pt",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div
          style={{
            padding: "0.5rem 0",
            width: "100%",
            letterSpacing: "initial",
            lineHeight: "1.3",
          }}
        >
          <span style={{ fontSize: "16pt", margin: 0, fontWeight: "700", display: "block", marginBottom: "0.25rem" }}>
            {props.onTitle}
          </span>
          <p style={{ margin: 0, fontSize: "10pt", lineHeight: "1.4" }}>{props.onSubTitle}</p>
        </div>
        <button
          className="management__button"
          onClick={() => {
            navigate(props.onNavigation);
          }}
        >
          <p style={{ margin: 0 }}>Manage {props.onTitle}</p>
          <span style={{ fontSize: "12pt" }}>{props.onIcon}</span>
        </button>
      </div>
    </div>
  );
};

export default ManagementOption;
